import sitesService from "@/services/sites";
// fetch sites with areas and kiosks
export default {
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    fetchSitesWithAreasAndKiosks() {
      this.isLoading = true;

      return new Promise((resolve, reject) => {
        sitesService
          .getSitesWithAreasAndKiosks()
          .then((data) => {
            // resolve(data.data);
            //   commit("modal/setModalState", false, { root: true });
            const dataSource = [];
            let totalKiosksInSite = 0;
            let currentTimezone = "";
            let journeyCheck = false;
            let areasCount = 0;
            let currentSite;
            let areasWithKiosks = [];
            let traverse = (node, parent_id) => {
              if (node.children?.length || node.parent_areas?.length) {
                //Do recursive call if a node with children field was found
                traverse(node.children || node.parent_areas, node.id);
              }
              // Check for elements with children field
              if (node.length) {
                node.forEach((elem) => {
                  if (elem.children) {
                    traverse(elem.children, elem.id);
                  }
                });

                // Reachable block only for last inner level
                // Check for areas and subareas
                // loop on all elements and assign their parent_id
                node.forEach((elem) => {
                  areasCount++;
                  if (elem.device && elem.device.length) {
                    totalKiosksInSite += elem.device.length;
                  }
                  //Add site name and id to all areas that belong to that site

                  const kiosksOnlyCount =
                    elem.device?.filter((device) => device.type == "0")
                      ?.length || 0;
                  Object.assign(elem, {
                    mod_Parent_ID: parent_id,
                    dataType: "area",
                    kioskCount:
                      elem.device && elem.device.length
                        ? elem.device.length
                        : 0,
                    kiosksOnlyCount,
                    timezone: currentTimezone,
                    parentSite: { id: currentSite.id, name: currentSite.name },
                  });
                  dataSource.push(elem);
                });

                // Check for kiosks and assign their area id as mod_Parent_ID
                // node => children array
                // elem => parent area of kiosks
                node.forEach((elem) => {
                  if (elem.device && elem.device.length) {
                    areasWithKiosks.push(elem);
                  }
                  if (elem.device && elem.device.length) {
                    // areasWithKiosks.push(elem)
                    elem.device.forEach((peripheral) => {
                      // eslint-disable-next-line no-unused-vars
                      let type = null;
                      if (peripheral.type == "0") {
                        type = "kiosk";
                        //Add site id to kiosk
                        Object.assign(peripheral, { site_id: currentSite.id });
                        //Set journey field of parent area to mixed if kiosk id is different
                        //from its area's id
                        if (
                          peripheral.journey &&
                          peripheral.journey.id &&
                          elem.journey_id != peripheral.journey.id &&
                          !journeyCheck
                        ) {
                          Object.assign(elem.journey, { name: "Mixed" });
                          journeyCheck = true;
                        }
                      } else if (peripheral.type == "1") type = "door";
                      Object.assign(peripheral, {
                        mod_Parent_ID: elem.id,
                        dataType: type,
                        timezone: currentTimezone,
                        parentAreaJourneyId: elem.journey_id,
                        journeys: currentSite.journeys,
                      });
                      dataSource.push(peripheral);
                    });
                    journeyCheck = false;
                  }
                });
              }
            };

            const assignNoOfKiosksToParentAreas = (
              areasWithKiosks,
              dataSource
            ) => {
              areasWithKiosks.forEach((elem) => {
                let parent_id = elem.parent_id;
                while (parent_id) {
                  let parentElem = dataSource.find((ds) => parent_id == ds.id);
                  Object.assign(parentElem, {
                    kioskCount: parentElem.kioskCount + elem.kioskCount,
                    kiosksOnlyCount:
                      parentElem.kiosksOnlyCount + elem.kiosksOnlyCount,
                  });
                  if (!parentElem.parent_id || parentElem.parent_id != parent_id) break;
                  parent_id = parentElem.parent_id;
                }
              });
            };

            data.data.forEach((site) => {
              //Set timezone in a var so all children can inherit same timzone
              currentTimezone = site.timezone;
              currentSite = site;
              traverse(site);

              //Assign no of kiosks to all parent areas
              assignNoOfKiosksToParentAreas(areasWithKiosks, dataSource);

              if (totalKiosksInSite) {
                Object.assign(site, { kioskCount: totalKiosksInSite });
              }
              dataSource.push(
                Object.assign(site, { areasCount, dataType: "site" })
              );

              totalKiosksInSite = 0;
              areasCount = 0;
              currentTimezone = "";
              areasWithKiosks = [];
            });
            this.isLoading = false;
            resolve(dataSource);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
